import { useCallback, useMemo, useState } from 'react';

import settings from '@src/conf';
import { isTokenExpired } from '@src/corelib/utils/jwtUtils';

const STORAGE_KEY = 'ReactStorage__Authentication';

function useJwtStorage() {
  const parse = () => {
    const value = localStorage.getItem(STORAGE_KEY);
    return value ? JSON.parse(value) : null;
  };

  const [credentials, setCredentials] = useState(parse);

  const isAccessTokenExpired = useMemo(
    () => isTokenExpired(credentials?.metadata?.accessTokenExpiredAt, settings.AUTH.JWT.EXPIRED_BUFFER),
    [credentials],
  );

  const isRefreshTokenExpired = useMemo(
    () => isTokenExpired(credentials?.metadata?.refreshTokenExpiredAt, settings.AUTH.JWT.EXPIRED_BUFFER),
    [credentials],
  );

  const isExpired = useMemo(
    () => isAccessTokenExpired || isRefreshTokenExpired,
    [isAccessTokenExpired, isRefreshTokenExpired],
  );
  const isAuthenticated = useMemo(() => !isExpired && Boolean(credentials), [credentials]);

  const set = useCallback((payload) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    setCredentials(payload);
  }, []);

  const remove = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(null));
    setCredentials(null);
  }, []);


  return {
    set,
    remove,
    parse,
    credentials,
    isAuthenticated,
  };
}

export { useJwtStorage };
